import { Config } from '../../_config'
import { UseCase } from '../../_kernel/architecture'
import { ID } from '../../_kernel/ID'
import { PropertyRepository } from '../domain/PropertyRepository'
import { PropertyRepositoryProxy } from '../infrastructure/PropertyRepositoryProxy'
import { LikeBelong } from '../domain/LikeBelong'

export interface GetUserLikesPropertyUseCaseInput {
  id: string
}

export default class GetUserLikesPropertyUseCase
  implements UseCase<GetUserLikesPropertyUseCaseInput, LikeBelong>
{
  static readonly USE_CASE_NAME = 'GetUserLikesPropertyUseCase'
  static create({ config, repository }: { config: Config; repository?: PropertyRepository }) {
    return new GetUserLikesPropertyUseCase(repository ?? PropertyRepositoryProxy.create({ config }))
  }

  constructor(private repository: PropertyRepository) {}

  async execute({ id }: GetUserLikesPropertyUseCaseInput) {
    return this.repository.isLiked({ id: ID.create({ value: id }) })
  }
}
